import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { OrganizationUserModel } from '@smarttask-common/src/lib/models/OrganizationUser/OrganizationUserModel';

export enum OrganizationUserActionTypes {
    ADD_USER = '[OrganizationUser] Create User',
    ADD_USERS = '[OrganizationUser] Add Users',
    UPSERT_USER = '[OrganizationUser] Upsert User',
    UPSERT_USERS = '[OrganizationUser] Upsert Users',
    UPDATE_USER = '[OrganizationUser] Update User',
    UPDATE_USERS = '[OrganizationUser] Update Users',
    DELETE_USER = '[OrganizationUser] Delete User',
    DELETE_USERS = '[OrganizationUser] Delete Users',
    DELETE_ALL_USERS = '[OrganizationUser] Delete All Users',
    DELETE_ALL = '[OrganizationUser] Delete All',

    UPDATE_SELECTED_ID = '[OrganizationUser] Update SelectedId',
}

export class UpdateSelectedUserId implements Action {
    readonly type = OrganizationUserActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_user_id: number) {}
}

export class AddOne implements Action {
    readonly type = OrganizationUserActionTypes.ADD_USER;
    constructor(public user: OrganizationUserModel) {}
}

export class AddMany implements Action {
    readonly type = OrganizationUserActionTypes.ADD_USERS;
    constructor(public users: Array<OrganizationUserModel>) {}
}

export class UpsertOne implements Action {
    readonly type = OrganizationUserActionTypes.UPSERT_USER;

    constructor(public user: OrganizationUserModel) {}
}

export class UpsertMany implements Action {
    readonly type = OrganizationUserActionTypes.UPSERT_USERS;
    constructor(public users: Array<OrganizationUserModel>) {}
}

export class UpdateOne implements Action {
    readonly type = OrganizationUserActionTypes.UPDATE_USER;
    constructor(public user: Update<OrganizationUserModel>) {}
}

export class UpdateMany implements Action {
    readonly type = OrganizationUserActionTypes.UPDATE_USERS;
    constructor(public users: Array<Update<OrganizationUserModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = OrganizationUserActionTypes.DELETE_USER;
    constructor(public id: number) {}
}

export class DeleteMany implements Action {
    readonly type = OrganizationUserActionTypes.DELETE_USERS;
    constructor(public ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = OrganizationUserActionTypes.DELETE_ALL_USERS;
    constructor(public ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = OrganizationUserActionTypes.DELETE_ALL;
    constructor() {}
}

export type OrganizationUserActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedUserId;
